import { render, staticRenderFns } from "./PathwayCohortViewStudentsSectionList.vue?vue&type=template&id=69ce0a63&"
import script from "./PathwayCohortViewStudentsSectionList.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortViewStudentsSectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports